import { render } from "./BecomeAFriend.vue?vue&type=template&id=36c2454f&scoped=true"
import script from "./BecomeAFriend.vue?vue&type=script&lang=js"
export * from "./BecomeAFriend.vue?vue&type=script&lang=js"

import "./BecomeAFriend.vue?vue&type=style&index=0&id=36c2454f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c2454f"]])

export default __exports__